import { useRouter } from 'next/router'

import { routes } from '~/config/routes'

import { AccessType } from '~/types'
import { accessToken } from '~/utils/access-token'
import { isEmpty } from '~/utils/is-empty'
import { redirectUser } from '~/utils/redirect-user'
import { getSelfServiceOnboardingRoute } from '~/utils/self-service-onboarding'
import { useGetCurrentUser } from './use-get-current-user'

export const useSignInUser = (type: AccessType = 'dashboard') => {
  const router = useRouter()
  const getCurrentUser = useGetCurrentUser()

  return async (token: string): Promise<void> => {
    // set access token
    accessToken.set(type, token)

    if (type === 'dashboard') {
      // fetch current user
      const user = (await getCurrentUser())!
      const expectedRoute = getSelfServiceOnboardingRoute(user)

      if (user.isMasterAdmin) {
        router.push(routes.dashboard.kindestAdmin.workspaces)
      } else if (expectedRoute) {
        router.push(expectedRoute)
      } else if (isEmpty(user.roles)) {
        throw new Error('User roles are empty')
      } else {
        redirectUser(user)
      }
    } else {
      router.push(routes.donorPortal.home)
    }
  }
}
